import * as React from "react"

// tracks color mode light/dark
export const ColorModeContext = React.createContext({
  toggleColorMode: () => {},
})
